import { render } from "./PlaceFilters.vue?vue&type=template&id=1b267fe8"
import script from "./PlaceFilters.vue?vue&type=script&lang=js"
export * from "./PlaceFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__